import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Injectable()
export class FormValidationService {

  constructor () { }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        // console.log('field [' + field + '] has error: ' + control.errors);
        control.setErrors(control.errors);
        control.markAsDirty({ onlySelf: true });
        control.markAsTouched({ onlySelf: true });

      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);

      } else if (control instanceof FormArray) {
        control.controls.forEach(singleGroup => {
          if (singleGroup instanceof FormGroup) {
            this.validateAllFormFields(singleGroup);
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/utils/form-validation.service.ts